import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { UserRoleEnum } from '../../types/apiGeneratedTypes';
import { useNavigate } from 'react-router';
import BiomarkersTab from '../../components/MedicalLibrary/BiomarkersTab';
import BodySystemsTab from '../../components/MedicalLibrary/BodySystemsTab';
import RecommendationsTab from '../../components/MedicalLibrary/RecommendationsTab';
import FoodsTab from '../../components/MedicalLibrary/FoodsTab';
import SupplementTab from '../../components/MedicalLibrary/SupplementTab';
import ConditionsTab from '../../components/MedicalLibrary/ConditionsTab';
import ResourceCenter from '../../components/ResourceCenter';
import PanelsTab from '../../components/MedicalLibrary/PanelsTab';
import NoteTemplatesTab from '../../components/MedicalLibrary/NoteTemplatesTab';
import PromptsTab from '../../components/MedicalLibrary/PromptsTab';
import QuotesTab from '../../components/MedicalLibrary/QuotesTab';
import TagsTab from '../../components/MedicalLibrary/tags';
import PmpModalitiesTab from '../../components/MedicalLibrary/PmpModalitiesTab';
import MriConditionsTab from '../../components/MedicalLibrary/MriConditionsTab';
import AppCmsTab from '../../components/MedicalLibrary/AppCmsTab';
import './MedicalLibrary.scss';

type MedicalLibraryTab =
  | 'biomarkers'
  | 'body-systems'
  | 'recommendations'
  | 'foods'
  | 'supplements'
  | 'conditions'
  | 'resource-center'
  | 'panels'
  | 'note-templates'
  | 'prompts'
  | 'quotes'
  | 'tags'
  | 'pmp-modalities'
  | 'mri-conditions'
  | 'app-cms';

const MEDICAL_LIBRARY_TABS: { id: MedicalLibraryTab; label: string }[] = [
  { id: 'biomarkers', label: 'Biomarkers' },
  { id: 'foods', label: 'Foods' },
  { id: 'recommendations', label: 'Recommendations' },
  { id: 'body-systems', label: 'Body Systems' },
  { id: 'supplements', label: 'Supplements' },
  { id: 'conditions', label: 'Medical Conditions' },
  { id: 'resource-center', label: 'Content' },
  { id: 'panels', label: 'Panels' },
  { id: 'note-templates', label: 'Note Templates' },
  { id: 'prompts', label: 'Prompts' },
  { id: 'quotes', label: 'Quotes' },
  { id: 'tags', label: 'Tags' },
  { id: 'pmp-modalities', label: 'PMP Modality' },
  { id: 'mri-conditions', label: 'MRI Conditions' },
  { id: 'app-cms', label: 'App CMS' },
];

const BodySystems: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<MedicalLibraryTab>('biomarkers');
  const { admin } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    if (admin.role === UserRoleEnum.Doctor || admin.role === UserRoleEnum.Nutritionist) navigate('/members');
  }, [admin.role, navigate]);

  return (
    <div className='page-container page-container2 medical-library-page'>
      <div className='tab-navigation medical-library-nav sideBarPad'>
        {MEDICAL_LIBRARY_TABS.map((tab) => (
          <button
            key={tab.id}
            type='button'
            className={activeTab === tab.id ? 'active' : ''}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className='tab-content'>
        {activeTab === 'biomarkers' && <BiomarkersTab />}
        {activeTab === 'recommendations' && <RecommendationsTab />}
        {activeTab === 'body-systems' && <BodySystemsTab />}
        {activeTab === 'foods' && <FoodsTab />}
        {activeTab === 'supplements' && <SupplementTab />}
        {activeTab === 'conditions' && <ConditionsTab />}
        {activeTab === 'resource-center' && <ResourceCenter />}
        {activeTab === 'panels' && <PanelsTab />}
        {activeTab === 'note-templates' && <NoteTemplatesTab />}
        {activeTab === 'prompts' && <PromptsTab />}
        {activeTab === 'quotes' && <QuotesTab />}
        {activeTab === 'tags' && <TagsTab />}
        {activeTab === 'pmp-modalities' && <PmpModalitiesTab />}
        {activeTab === 'mri-conditions' && <MriConditionsTab />}
        {activeTab === 'app-cms' && <AppCmsTab />}
      </div>
    </div>
  );
};
export default BodySystems;
